<template>
  <div>
    <CheckboxGroup :class="{'checkbox_disable': disabled}" v-model="tempDataList" @on-change="changeDataList" :style="{'max-width':maxWidth}">
      <Checkbox v-for="item in enumList" :label="item.code" :disabled="item.disabled" :style="{'display':display,'font-size':fontSize}">
        <span>{{item.value}}</span>
      </Checkbox>
      <slot></slot>
    </CheckboxGroup>
  </div>
</template>
<script>

export default {
  name: "MyCheckBox",
  props: {
    enumList: Array,
    disabled: {
      type: Boolean,
      default: ()=>{return false}
    },
    display: {
      type: String,
      default: ()=>{return 'inline-block'}
    },
    fontSize:{
      type: String,
      default: ()=>{return ''}
    },
    maxWidth:{
      type: String,
      default: ()=>{return ''}
    },
    dataStr: [String, Number],
    dataList:{
      type: Array,
      default: ()=>{return []}
    },
    ignoreList:{
      type: Array,
      default: ()=>{return []}
    },
    label:{
      type: String,
      default: ()=>{return 'code'}
    },
    value:{
      type: String,
      default: ()=>{return 'value'}
    }
  },
  watch:{
    dataStr:{
      handler(newData, oldData) {
        this.watchDataStrChange(newData, oldData);
      },
    },
    dataList:{
      handler(newData, oldData){
        if (newData && newData.length > 0){
          if (this.$props.ignoreList.indexOf(newData[newData.length-1]) > -1){
            if (newData.toString() == oldData.toString()){
              return
            }
            this.$emit("update:dataList",this.$props.ignoreList)
            this.$emit("update:dataStr",this.$props.ignoreList.toString())
            this.$emit("on-change",this.$props.ignoreList.toString())
          } else{
            this.$props.ignoreList.forEach(item =>{
              if (newData.indexOf(item) > -1){
                newData.splice(newData.indexOf(item),1)
              }
            })
            this.$emit("update:dataList",newData)
            this.$emit("update:dataStr",newData.toString())
            this.$emit("on-change",newData.toString())
          }
        }
      }
    }
  },
  data(){
    return{
      tempDataList: [],
      tempStr: ''
    }
  },
  methods: {
    watchDataStrChange(newData, oldData){
      if (newData && newData.length > 0){
        this.tempDataList = newData.split(',');
        //console.log(this.tempDataList,'this.tempDataList')
        this.tempDataList = [...new Set(this.tempDataList)]
        this.$emit("update:dataList",this.tempDataList)
        this.tempStr = this.tempDataList.toString()
        if (this.tempStr.length != newData.length){
          this.$emit("update:dataStr",this.tempStr)
          this.$emit("on-change",this.tempStr)
        }
      } else {
        this.tempDataList = [];
        this.$emit("update:dataList",this.tempDataList)
      }

    },
    changeDataList(list){
      list = [...new Set(list)]
      this.tempStr = list.toString()
      this.$emit("update:dataList",list)
      this.$emit("update:dataStr",this.tempStr)
      this.$emit("on-change",this.tempStr)
    }
  },
  mounted() {
    this.$nextTick(()=>{
      //console.log("执行MycheckBox值初始化.......",this.$props.dataStr)
      this.watchDataStrChange(this.$props.dataStr, "");
      // this.$emit("on-change","")
    })
  }
};
</script>
<style lang="postcss" scoped>

  .checkbox_disable{
    height: auto;
    -moz-opacity:0.8;
    opacity:0.8;
    pointer-events: none;
    -ms-filter: blur(10px);
    filter:  blur( 10 px);
  }
</style>
